import { snakeToPascalCase } from '@/main/utils/stringHelper';

import { DmsBaseComponent } from '#components/dms/common/base';

export const BaseInput = DmsBaseComponent.extend({
	props: {
		value: [String, Number, Boolean],
		validationProperty: String,
		validationRules: [Object, Array],
		validationOff: Boolean,
		clearable: { type: Boolean, default: true },
		showLabel: { type: Boolean, default: true },
		wrapp: { type: Boolean, default: true },
	},
	data() {
		return {
			formItem: null as any,
		};
	},
	watch: {
		value(val) {
			if (this.clearable && val !== null && val.length === 0) {
				this.$emit('clear');
			}
		},
	},
	computed: {
		valueCmp: {
			get(): string | number | boolean {
				return this.value;
			},
			set(val: string | number | boolean) {
				this.$emit('update:value', val);
			},
		},
		validationPropertyCmp(): string | undefined {
			if (this.validationOff) {
				return undefined;
			}
			if (!this.validationProperty && !this.labelKey) {
				console.warn('Validation on but no validationProperty defined');
				return undefined;
			}

			return (this.validationProperty || snakeToPascalCase(this.labelKey));
		},
	},
});
